import useScreenSize from '../../hooks/useScreenSize'
import MixtilesDialog from '../MixtilesDialog/MixtilesDialog'
import Button from 'mixtiles-web-common/ui/Button'
import { Drawer } from '@mui/material'
import { ReactComponent as Background } from './SuccessDialogBackground.svg'
import './SuccessDialog.scss'
import * as S from './SuccessDialog.styles'
import { useProductType } from '../../services/ProductTypesManager'
import { ILLUSTRATIONS } from 'mixtiles-web-common/consts/illustrations.const'
import { PRODUCT_TYPES } from '../../services/ProductTypeState'
import { useTranslation } from 'react-i18next'

function DrawerContainer({ children, open, onDismiss, hideBackdrop }) {
  return (
    <Drawer
      classes={{
        paper: 'success-drawer-container',
        root: 'success-drawer-container-root',
      }}
      open={open}
      onClose={onDismiss}
      anchor="bottom"
      transitionDuration={{ enter: 350, exit: 250 }}
      hideBackdrop={hideBackdrop}
    >
      {children}
    </Drawer>
  )
}

function SuccessDialog({ show, onDismiss, title, text, noBackground }) {
  const isMediumScreen = useScreenSize('md')
  const { productType } = useProductType()
  const { t } = useTranslation()
  const DONE = t('general.done')

  const Container = !isMediumScreen ? DrawerContainer : MixtilesDialog

  return (
    <Container
      open={show}
      onDismiss={onDismiss}
      fullScreen={false}
      className="success-dialog-container"
      hideBackdrop
    >
      <div className="SuccessDialog">
        {!noBackground && (
          <div className="background">
            {' '}
            <Background />{' '}
          </div>
        )}
        <S.SuccessIllustration
          name={
            productType === PRODUCT_TYPES.GIFT_CARD
              ? ILLUSTRATIONS.GIFTING.COUPLE_WITH_GIFT
              : ILLUSTRATIONS.MOMENTS.OKAY_HAND_HAPPY_WATCH
          }
        />
        <div className="content">
          <S.Title className="success-title" data-testid="success-dialog-title">
            {title}
          </S.Title>
          <S.Text className="success-message">{text}</S.Text>
          <S.Cta>
            <Button
              minWidth={162}
              onClick={onDismiss}
              testId="success-dialog-done-button"
            >
              {DONE}
            </Button>
          </S.Cta>
        </div>
      </div>
    </Container>
  )
}

export default SuccessDialog
